var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditionalHourIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6966 21H11.8296V15.357H9.5306V16.292H10.6966V21Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 21H14.4437V18.492C14.4437 17.744 14.9167 17.304 15.6427 17.304C16.2917 17.304 16.5997 17.689 16.5997 18.349V21H17.7107V18.261C17.7107 17.007 17.0067 16.281 15.9837 16.281C15.2907 16.281 14.7407 16.622 14.4437 17.194V13.058H13.3327V21Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7625 23.7625C39.9109 20.6141 39.9109 15.5096 36.7625 12.3612C33.6141 9.21292 28.5096 9.21292 25.3612 12.3612C22.2129 15.5096 22.2129 20.6141 25.3612 23.7625C28.5096 26.9109 33.6141 26.9109 36.7625 23.7625Z",
    fill: "#3C3C3C",
    stroke: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5538 18.0619H34.5699",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0619 21.57V14.5538",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3388 26.3389C27.2204 21.4573 27.2204 13.5427 22.3388 8.66114C17.4573 3.77962 9.54275 3.77962 4.66115 8.66114C-0.220383 13.5427 -0.220383 21.4573 4.66115 26.3389C9.54275 31.2204 17.4573 31.2204 22.3388 26.3389Z",
    stroke: "#3C3C3C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalHourIcon);
export default __webpack_public_path__ + "static/media/additional_hour_icon.8e73d4ae343e56a48aa1c2aebb56b226.svg";
export { ForwardRef as ReactComponent };